import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import ErrorLoadingWidget from "../ErrorLoadingWidget";
import { LoadingWidget } from "../LoadingWidget";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import TableWidget from "./TableWidget";
import { primaryProperty, useGetAllBusinesses } from "@api/businessService";

export default function ListWidget({
    query,
    requestParams = null,
    columns,
    options,
    relationship = null,
    include = 'all',
    ...restProps
}) {

    // console.log(include);

    let propOpts = {
        per_page: -1,
        include: include,
    };

    if(requestParams) {
        propOpts = {
            ...propOpts,
            ...(requestParams ?? {}),
        };
    }
    else if(options.ids) {
        propOpts.id = options.ids.join(',');
    }

    // this is used to reduce duplicate code in index vs show
    const queryProps = [
        {
            ...propOpts,
        },
        {
            retry: false,
        }
    ];
    if(options.id) {
        queryProps.unshift(options.id);
    }

    const {
        // isPending,
        isLoading,
        isError,
        error,
        data,
        isFetching,
        isPreviousData,
    } = query(...queryProps);

    if(isLoading) {
        return <LoadingWidget/>
    }

    if(isError) {
        return <ErrorLoadingWidget {...restProps} error={true} />
    }

    return (
        <TableWidget
            {...restProps}
            columns={columns}
            // headers={['Name', 'Address'/*Open today*/]}
            data={data}
            relationship={relationship}
        />
    );
}
